<script lang="ts">
    import WindVector from "../../../public/icons/wind_vector.svelte";
    import { conditions, cType, Observation, Widget, widgetInfo, WidgetType } from "../../store";

    export let isPrimaryCondition: boolean = false;

    let fill = "--default-color"
    let errorFill = "--error-color"
    let threshold = undefined;
    let conditionValue;
    let windGustDirection;
    let windGustSpeed;

    widgetInfo.subscribe((value: Widget) => {
        if (value) {
            if(value.type != WidgetType.DEF && isPrimaryCondition){
                fill = "--primary-color"
            }
            if (isPrimaryCondition && value.policies) { // NPA
                threshold = value.primaryThreshold;
            } else {
                const currentConditions = value.widgetConditions;
                const gustCondition = currentConditions.find(
                    condition => condition.conditionType === cType.GUST
                );
                if (gustCondition) {
                    threshold = gustCondition.threshold;
                }
            }
        }
    });

    conditions.subscribe((value: Observation) => {
        if(value && value.windGust){
            windGustSpeed = value.windGust.value;
            conditionValue = Math.round(windGustSpeed);
            windGustDirection = value.windGustDirection;
            if(threshold != undefined && windGustSpeed >= threshold)
                fill = errorFill;
        }
        else{
            conditionValue = "--";
        }
    });

</script>

<div class="cc-container" style="color: var({fill});">
    <div class="weatherIcon">
        <WindVector fill="var({fill})" direction={windGustDirection}/>
    </div>

    <div class="{isPrimaryCondition ? "primary-value":"value"}">
        <span>{conditionValue}</span>{#if windGustSpeed > 0 && windGustDirection}<span style="font-size:50%;">{windGustDirection}</span>{/if}
    </div>

    <div class="{isPrimaryCondition ? "primary-label" : "label"}">Gust</div>



  </div>
